$(document).ready(function() {
    var businessRate1, medicalRate1, movingRate1, charityRate1;
    var formatNumber = function formatNumber(number) {
        return Number(number).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    };
    var formatRate = function formatRate(number) {
        var cents = Number(number) * 100;
        var formattedCents = cents.toFixed(2).toString();
        var trimmedCents = parseFloat(formattedCents).toString();
        return `${trimmedCents}c`;
    };
    function calculateMileageDeduction(businessMiles1, medicalMiles1, movingMiles1, charityMiles1) {
        var businessDeduction = 0, medicalDeduction = 0, movingDeduction = 0, charityDeduction = 0;
        if (businessMiles1 > 0) businessDeduction = businessMiles1 * businessRate1;
        if (medicalMiles1 > 0) medicalDeduction = medicalMiles1 * medicalRate1;
        if (movingMiles1 > 0) movingDeduction = movingMiles1 * movingRate1;
        if (charityMiles1 > 0) charityDeduction = charityMiles1 * charityRate1;
        $('#businessDeduction').text(formatNumber(businessDeduction));
        $('#medicalDeduction').text(formatNumber(medicalDeduction));
        $('#movingDeduction').text(formatNumber(movingDeduction));
        $('#charityDeduction').text(formatNumber(charityDeduction));
        var totalDeduction = Number(businessDeduction) + Number(medicalDeduction) + Number(movingDeduction) + Number(charityDeduction);
        $('.total-deduction').text(formatNumber(totalDeduction));
        var totalDistance = Number(businessMiles1) + Number(medicalMiles1) + Number(movingMiles1) + Number(charityMiles1);
        $('.total-distance').text(formatNumber(totalDistance));
    }
    function loadData() {
        var businessMiles1 = parseFloat(sessionStorage.getItem('businessMiles1')) || 0;
        var medicalMiles1 = parseFloat(sessionStorage.getItem('medicalMiles1')) || 0;
        var movingMiles1 = parseFloat(sessionStorage.getItem('movingMiles1')) || 0;
        var charityMiles1 = parseFloat(sessionStorage.getItem('charityMiles1')) || 0;
        businessRate1 = parseFloat(sessionStorage.getItem('businessRate1'));
        medicalRate1 = parseFloat(sessionStorage.getItem('medicalRate1'));
        movingRate1 = parseFloat(sessionStorage.getItem('movingRate1'));
        charityRate1 = parseFloat(sessionStorage.getItem('charityRate1'));
        $('#businessRateEdit').text(formatRate(businessRate1));
        $('#medicalRateEdit').text(formatRate(medicalRate1));
        $('#movingRateEdit').text(formatRate(movingRate1));
        $('#charityRateEdit').text(formatRate(charityRate1));
        $('#business1').val(businessMiles1);
        $('#medical1').val(medicalMiles1);
        $('#moving1').val(movingMiles1);
        $('#charity1').val(charityMiles1);
        calculateMileageDeduction(businessMiles1, medicalMiles1, movingMiles1, charityMiles1);
    }
    loadData();
    $('#business1, #medical1, #moving1, #charity1').on('input', function() {
        var businessMiles1 = $('#business1').val();
        var medicalMiles1 = $('#medical1').val();
        var movingMiles1 = $('#moving1').val();
        var charityMiles1 = $('#charity1').val();
        calculateMileageDeduction(businessMiles1, medicalMiles1, movingMiles1, charityMiles1);
    });
    $('#editButton').click(function(e) {
        $('#editButton').hide();
        $('#ctaFeatures').hide();
        $('#editForm').css('display', 'flex');
    });
    $('.input_field').submit(function() {
        return false;
    });
});

//# sourceMappingURL=mileage-deduction-result.cf75908d.js.map
